import React from "react";
import setNavigation from "./../../actions/set_navigation";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { Col } from "Components";
class Services extends React.Component {
  render = () => (
    <div className="container row services">
      <Col className="item" l={3} m={12}>
        <div className="icon_holder">
          <div className="campanies" />
        </div>
        <div className="content_holder">
          <p className="title"> KAMPANYALAR </p>
          <p className="description">
            Kampanyalarımızı görüntüleyebilir, kredi fırsatlarımızı
            inceleyebilirsiniz.
          </p>
        </div>
      </Col>
      <Col className="item" l={3} m={12}>
        <Link
          onClick={() => {
            this.setState({ show_menu: false });
            this.props.setNavigation(["branches"]);
          }}
          to={"/branches"}
        >
          <div className="icon_holder">
            <div className="branches" />
          </div>
          <div className="content_holder">
            <p className="title"> ŞUBE ve ATM’LER </p>
            <p className="description">
              Size en yakın şube ve ATM'ler imizi harita üzerinde
              görüntüleyebilirsiniz.
            </p>
          </div>
        </Link>
      </Col>
      <Col className="item" l={3} m={12}>
        <Link
          onClick={() => {
            this.setState({ show_menu: false });
            this.props.setNavigation(["uban"]);
          }}
          to={"/uban"}
        >
          <div className="icon_holder">
            <div className="submit" />
          </div>
          <div className="content_holder">
            <p className="title"> UBAN SORGULA </p>
            <p className="description">
              UBAN Sorgulama aracını kullanarak UBAN numaranızı kolayca
              sorgulayabilir.
            </p>
          </div>
        </Link>
        {/* <Link
          onClick={() => {
            this.setState({ show_menu: false });
            this.props.setNavigation(["card_application"]);
          }}
          to={"/card_application"}
        >
          <div className="icon_holder">
            <div className="submit" />
          </div>
          <div className="content_holder">
            <p className="title"> HEMEN BAŞVUR </p>
            <p className="description">
              Ürünlerimizden yararlanmaya başlamak için başvuru yapabilirsiniz.
            </p>
          </div>
        </Link> */}
      </Col>
      <Col className="item" l={3} m={12}>
        <Link
          onClick={() => {
            this.setState({ show_menu: false });
            this.props.setNavigation(["money_gram"]);
          }}
          to={"/money_gram"}
        >
          <div className="icon_holder">
            <div className="moneygram" />
          </div>
          <div className="content_holder">
            <p className="title"> MONEYGRAM </p>
            <p className="description">
              Başvurularınızın güncel durumunu öğrenebilirsiniz.
            </p>
          </div>
        </Link>
      </Col>
    </div>
  );
}
const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setNavigation
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Services);
